import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { horoscopeService, PromoStatus } from '../services/horoscopeApi';

const PromoBanner: React.FC = () => {
  const [promo, setPromo] = useState<PromoStatus | null>(null);

  useEffect(() => {
    horoscopeService.getPromo()
      .then(setPromo)
      .catch(() => {});
  }, []);

  const visible = promo?.active && promo?.banner;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.4 }}
          className="max-w-7xl mx-auto px-4 sm:px-6 pt-4"
        >
          <div
            className="rounded-2xl px-5 py-3.5 flex items-center gap-3"
            style={{
              background: 'linear-gradient(135deg, rgba(217,119,6,0.28) 0%, rgba(245,158,11,0.18) 100%)',
              border: '1px solid rgba(245,158,11,0.45)',
            }}
          >
            <Sparkles size={18} className="text-amber-400 flex-shrink-0" />
            <p className="text-amber-200 text-sm font-medium flex-1">{promo!.banner}</p>
            {promo!.until && (
              <span className="text-amber-400/70 text-xs flex-shrink-0">
                até {promo!.until.split('-').reverse().join('/')}
              </span>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PromoBanner;
